import React, { useEffect, useState } from 'react';
import { FiAward, FiBriefcase, FiUsers, FiUserCheck } from 'react-icons/fi';
import useInView from './useInView';
import reveal from './reveal.module.css';
import styles from './Indicadores.module.css';

function Counter({ to, suffix = '', start, duration = 1800 }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return undefined;
    let rafId;
    let startTime = null;
    const tick = (now) => {
      if (startTime === null) startTime = now;
      const progress = Math.min((now - startTime) / duration, 1);
      setCount(Math.floor(progress * to));
      if (progress < 1) {
        rafId = requestAnimationFrame(tick);
      } else {
        setCount(to);
      }
    };
    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [start, to, duration]);

  return (
    <span>
      {count}
      {suffix}
    </span>
  );
}

const stats = [
  { icon: FiAward, value: 14, suffix: '+', label: 'Años de experiencia' },
  { icon: FiBriefcase, value: 80, suffix: '+', label: 'Proyectos realizados' },
  { icon: FiUsers, value: 50, suffix: '+', label: 'Clientes' },
  { icon: FiUserCheck, value: 40, suffix: '+', label: 'Colaboradores' },
];

function Indicadores() {
  const [ref, inView] = useInView(0.2);

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {stats.map(({ icon: Icon, value, suffix, label }, i) => (
            <div
              key={label}
              className={`${styles.stat} ${reveal.reveal} ${
                inView ? reveal.visible : ''
              }`}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <Icon className={styles.icon} />
              <div className={styles.number}>
                <Counter to={value} suffix={suffix} start={inView} />
              </div>
              <div className={styles.label}>{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Indicadores;